export enum EmployeeRole {
    Employee = "Employee",
    Manager = "Manager",
    // Owner = "Собственик"
}